'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../../core/translator');
const Container = require('./../../../../core/container');

const designRepo = require('./../../repository/DesignRepository');

const zone = require('./../../../../services/structure/zone');
const fixHeight = require('./../../../../services/fixHeight');
const FormBuilder = require('./../../../../services/form');
const Notifier = require('./../../../../services/notifier');
const Loader = require('./../../../../services/loader');
const FlashMessage = require('./../../../../services/flashMessage');

const changePrimaryColor = function($conserveColor, $themes, primary) {
   $themes.each(function() {
      let $primaryColor = jQuery(this).find('.primary-color');
      let themePrimaryColor = $primaryColor[0].dataset.color;

      $conserveColor[0].checked ? $primaryColor.css('background-color', primary) : $primaryColor.css('background-color', themePrimaryColor);
   });
};

module.exports.onClick = function() {
   let $container = jQuery('<div class="theme-panel"></div>');

   let $layer = zone.addLayer(Translator.translate('themes'), $container);

   Loader.start($layer);
   designRepo.getAllThemes().done(function(data) {
      designRepo.getCurrentTheme().done(function(currentTheme) {
         designRepo.getColorPanel().done(function(colorPanel) {
            let elements = {
               'conservePrimaryColor': {
                  'label': Translator.translate('conserve_primary_color'),
                  'type': 'switch',
                  'value': true,
               },
            };

            data.forEach((element)=> {
               elements[element.unique_name] = {
                  'uniqueName': element.unique_name,
                  'isChecked': (currentTheme.unique_name === element.unique_name),
                  'primary': element.color_panel.primary.color,
                  'secondary': element.color_panel.secondary.color,
                  'textColor': element.color_panel.textColor.color,
                  'backgroundColor': element.color_panel.backgroundColor.color,
                  'type': 'themeColorElement',
               };
            });

            let form = FormBuilder.getForm({
               'elements': elements,
               'form': {
                  'submit_class': 'd-none',
               },
            });

            $container.append(form.render());
            Loader.stop($layer);

            let $conserveColor = $container.find('[name="conservePrimaryColor"]');
            let $themes = form.$.find('[class^="element"]').not('.element_conservePrimaryColor, .element_submit');

            changePrimaryColor($conserveColor, $themes, colorPanel.primary.color);

            $conserveColor.on('click', function() {
               changePrimaryColor($conserveColor, $themes, colorPanel.primary.color);
            });

            form.on('submit', (data) => {
               let themeParameters = {};
               let parameter;

               for (parameter in data) {
                  if (parameter === 'conservePrimaryColor') {
                     themeParameters['conserve_primary_color'] = data[parameter];
                  } else {
                     themeParameters['unique_name'] = data[parameter];
                  }
               }

               zone.hidePanels(Container.get('$smallPanel'));
               designRepo.changeTheme(themeParameters).done(function() {
                  FlashMessage.addCallback('colors-submit');
                  Notifier.success(Translator.translate('parameters_saved'));
                  location.reload();
               });
            });

            zone.setFooter($layer, zone.createSubmitButtons({
               onSubmitClick: form.submit.bind(form),
            }));

            fixHeight.fix($container, jQuery(window).height() - 165);
         });
      });
   });
};
